var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "基础信息" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "工号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "employeeNo"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入工号",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.employeeNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "employeeNo", $$v)
                                  },
                                  expression: "model.employeeNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "姓名",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "name"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入姓名",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "法人",
                                labelCol: _vm.labelCol2,
                                wrapperCol: _vm.wrapperCol2,
                                prop: "legalPerson"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入法人",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.legalPerson,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "legalPerson", $$v)
                                  },
                                  expression: "model.legalPerson"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "事业群",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "buName"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "disabled" },
                                model: {
                                  value: _vm.model.buName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "buName", $$v)
                                  },
                                  expression: "model.buName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "事业处",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "buName"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "disabled" },
                                model: {
                                  value: _vm.model.buName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "buName", $$v)
                                  },
                                  expression: "model.buName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "手机",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "mobile"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入手机",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.mobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "mobile", $$v)
                                  },
                                  expression: "model.mobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "是否在职",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "isWork"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "list",
                                  dictCode: "pre_job_status",
                                  placeholder: "请选择是否在职"
                                },
                                model: {
                                  value: _vm.model.isWork,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "isWork", $$v)
                                  },
                                  expression: "model.isWork"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "邮箱",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "email"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入邮箱",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }